module.exports = __webpack_public_path__ + "media/images/menu/corona_australis-71ed453e985db7cdfb2acf5d2e0e32dc.jpg";